export enum InvoiceModality {
    "", "Per e-mail", "Per post"
}